import React, { useCallback, useState } from 'react'

import { Col, Row, Typography } from 'antd'
import _ from 'lodash'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import { Paginator } from 'primereact/paginator'

import { useRequestReportMutation } from '../../../../appRedux/ducks/reports'
import { getMessage } from '../../../../util/IntlMessages'
import { filterNormalize } from '../../util/filterNormalize'
import { ColumnsChange } from '../ColumnsChange'

import './styles.less'

export const Preview = ({
  setColumnsSelected,
  columnsDynamic,
  setColumnsDynamic,
  columnsSelected,
  reportSelectedValues,
  formValues,
  setFilterValue,
  totalItems,
  selectedPageSize,
  setSelectedPagesize,
  setSelectedCurrentPage,
  filterReport,
  basicFirst,
  setBasicFirst
}) => {
  const [pageSize, setPageSize] = useState(20)
  const [isLoading, setIsLoading] = useState(false)

  const onBasicPageChange = (event) => {
    const page = Math.ceil((event.first + 1) / event.rows)

    setBasicFirst(event.first)
    setSelectedCurrentPage(page)
    setPageSize(event.rows)
    setSelectedPagesize(event.rows)
  }

  const normalizeParams = useCallback(
    (params) => ({
      params: filterNormalize(params),
      columns: columnsSelected.reduce((acc, col) => {
        return { ...acc, [col.field]: col.headerName }
      }, {})
    }),
    [formValues, columnsSelected]
  )

  const [requestReport, { isLoading: isLoadingReport }] = useRequestReportMutation()

  const requestBackgroundReport = async () => {
    const payload = normalizeParams(formValues)
    const { reportType } = payload.params

    await requestReport({ reportType, payload })
  }

  return (
    <div className="report-preview">
      <Row className="report-preview__header">
        <Col className="report-preview__columns-selector">
          <ColumnsChange
            setColumnsSelected={setColumnsSelected}
            columnsDynamic={columnsDynamic}
            setColumnsDynamic={setColumnsDynamic}
          />
        </Col>
      </Row>
      <Row>
        <Col className="report-preview__export-wrapper">
          <Typography.Text className="report-preview__title">{getMessage('reportPreview')}</Typography.Text>
          <Button
            label={getMessage('exportExcel')}
            loading={isLoadingReport}
            type="button"
            className="p-button-success report-preview__btn-export"
            icon="pi pi-file-excel"
            severity="success"
            onClick={requestBackgroundReport}
            data-pr-tooltip="XLS"
          />
        </Col>
      </Row>
      <div className="report-preview__table-wrapper">
        <DataTable
          value={reportSelectedValues}
          scrollable
          scrollHeight="70vh"
          filterDisplay="row"
          resizableColumns
          stripedRows
          size="small"
          tableStyle={{ minWidth: '50rem' }}
          className="p-datatable-scrollable report-preview__table"
          lazy
          loading={isLoading}
        >
          {columnsSelected.map((col) => (
            <Column
              key={col.field}
              header={col.headerName}
              field={col.field}
              filterField={col.field}
              showFilterMenu={false}
              filterMenuStyle={{ width: '20%' }}
              className="report-preview__table-column"
              body={(row) => (col.cellRenderer ? col.cellRenderer({ value: row[col.field] }) : row[col.field])}
              filter
              filterElement={(options) => {
                return (
                  <FilterInput
                    filterReport={async (query) => {
                      setIsLoading(true)
                      setFilterValue('otherFilters', {
                        ...formValues.otherFilters,
                        [options.field]: query
                      })
                      const params = filterNormalize(formValues, true, selectedPageSize, 1)
                      const payload = {
                        ...params,
                        otherFilters: {
                          ...params.otherFilters,
                          [options.field]: query
                        }
                      }
                      await filterReport(payload, true)
                      setBasicFirst(0)
                      setSelectedCurrentPage(1)
                      setIsLoading(false)
                    }}
                  />
                )
              }}
              responsive={true}
            />
          ))}
        </DataTable>
        <Paginator
          first={basicFirst}
          rows={pageSize}
          totalRecords={totalItems}
          rowsPerPageOptions={[20, 50, 75, 100]}
          onPageChange={onBasicPageChange}
        />
      </div>
    </div>
  )
}

function FilterInput({ filterReport }) {
  const filter = _.debounce((query) => {
    filterReport(query)
  }, 1000)

  return <InputText className="report-preview__table-search" onChange={(event) => filter(event.target.value)} />
}
